// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { OfficeResource_abstract } from './../abstract/SagaSchema/OfficeResource_abstract';
export class OfficeResource extends OfficeResource_abstract {}
